import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendPageView } from '../utils/analytics';

/**
 * Кастомный хук usePageTracking для автоматического отслеживания просмотров страниц (pageviews) в GA4.
 *
 * При каждом изменении пути (location.pathname + location.search) отправляет событие page_view в GA4
 * с небольшой задержкой, чтобы страница успела обновить document.title.
 */
export const usePageTracking = (): void => {
  const location = useLocation();
  const lastTrackedPathRef = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    // Предотвращаем повторную отправку одного и того же пути при ререндерах
    if (lastTrackedPathRef.current === currentPath) {
      return;
    }
    lastTrackedPathRef.current = currentPath;

    // Небольшая задержка, чтобы дочерние компоненты страниц успели выставить document.title
    const timer = setTimeout(() => {
      sendPageView(currentPath, typeof document !== 'undefined' ? document.title : '');
    }, 50);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);
};

export default usePageTracking;

